import React from 'react';

const STEPS = [
  {
    n: '1',
    title: 'Sign in with Google',
    body: 'One click — no new passwords to remember. Your chats stay with your account.',
  },
  {
    n: '2',
    title: 'Type, upload, or talk',
    body: 'Ask in writing, attach an image or PDF, or tap the mic and just say it out loud.',
  },
  {
    n: '3',
    title: 'Work it out together',
    body: 'You get hints and questions back, not just answers — so the idea actually sticks.',
  },
];

export default function HowItWorks() {
  return (
    <section id="how-it-works" className="scroll-mt-24 bg-brand-navy py-14 sm:py-16">
      <div className="mx-auto max-w-landing px-4 sm:px-6 lg:px-8">
        <div className="max-w-2xl">
          <p className="text-sm font-semibold uppercase tracking-wide text-white/70">How it works</p>
          <h2 className="mt-2 font-display text-3xl font-extrabold text-white sm:text-4xl">
            Ready in three simple steps
          </h2>
        </div>

        <div className="mt-10 grid gap-6 md:grid-cols-3">
          {STEPS.map((step) => (
            <div
              key={step.n}
              className="rounded-card border border-white/10 bg-white/10 p-6 backdrop-blur-sm"
            >
              <div className="flex h-10 w-10 items-center justify-center rounded-full bg-white font-display text-lg font-extrabold text-brand-navy">
                {step.n}
              </div>
              <h3 className="mt-4 font-display text-xl font-bold text-white">{step.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-white/75">{step.body}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
